import { Button, useOpenable } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';
import LCModal from '../../../HomePage/Components/LCModal';
import { trackIntercomEvent } from '../../../services/intercomTrackingService';

function CreateCollectionButton() {
  const { onOpen, isOpen, onClose } = useOpenable();

  const handleClick = () => {
    trackIntercomEvent('Learning Collections - Create a Collection');
    onOpen();
  };

  return (
    <>
      <Button
        className="rounded-md bg-teal-600 px-3 py-2 text-xs text-white w-auto gap-x-0"
        onClick={handleClick}
        data-intercom-target="create-a-collection-button"
        fullWidth
      >
        <span className="mr-1">&#43;</span>
        <T kind="Create a Collection" />
      </Button>
      <LCModal isOpen={isOpen} onClose={onClose} context="Learning Collections" />
    </>
  );
}

export default observer(CreateCollectionButton);
